import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'
import { Link } from 'react-router-dom'

import { onChangePasswordDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import { validatePasswordField, isPasswordValid } from '../../../utils/passwordRules'
import PasswordStrength from '../../generic/PasswordStrength'
import keyUpHandler from '../../utils/keyUpHandler'
import InlineError, { ariaErrorProps } from '../../generic/InlineError'
import '../../generic/RenderedField/styles.css'
import './styles.css'

export function ChangePassword({ onSubmit, hideGlobalNav, showGlobalNav }) {
  const [oldPasswordVisible, setOldPasswordVisible] = useState(false)
  const [password1Visible, setPassword1Visible] = useState(false)
  const [password2Visible, setPassword2Visible] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    formState: { isSubmitting, errors, isDirty }
  } = useForm()

  const password1 = watch('password1')

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
  }, [hideGlobalNav, showGlobalNav])

  return (
    <div id="ChangePassword" className="auth-page">
      <div>
        <div className="logo">
          <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
        </div>

        <div className="change-password-box auth-form-box">
          <h1>Change your password</h1>
          <form id="SignInForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', '-floating', { '-error': errors.oldPassword })}>
              <div className="field-container">
                <input
                  {...register('oldPassword', {
                    required: 'This field is required.'
                  })}
                  type={oldPasswordVisible ? 'text' : 'password'}
                  placeholder=" "
                  id="change-old-password"
                  {...ariaErrorProps('change-old-password', errors.oldPassword)}
                />
                <label htmlFor="change-old-password">Your old password</label>
                <i
                  className={classnames('icon', oldPasswordVisible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setOldPasswordVisible(!oldPasswordVisible)}
                  onKeyUp={event => keyUpHandler(event, () => setOldPasswordVisible(!oldPasswordVisible))}
                  tabIndex="0"
                />
                <InlineError id="change-old-password" message={errors.oldPassword?.message} />
              </div>
            </div>
            <div className="forgot-password">
              <Link to="/users/password/new">Forgot password?</Link>
            </div>
            <div className={classnames('field', '-with-feedback', '-floating', { '-error': errors.password1 })}>
              <div className="field-container">
                <input
                  {...register('password1', {
                    required: 'This field is required.',
                    validate: validatePasswordField
                  })}
                  type={password1Visible ? 'text' : 'password'}
                  placeholder=" "
                  id="change-new-password"
                  {...ariaErrorProps('change-new-password', errors.password1)}
                />
                <label htmlFor="change-new-password">Your new password</label>
                <i
                  className={classnames('icon', password1Visible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword1Visible(!password1Visible)}
                  onKeyUp={event => keyUpHandler(event, () => setPassword1Visible(!password1Visible))}
                  tabIndex="0"
                />
                <InlineError id="change-new-password" message={errors.password1?.message} />
              </div>
            </div>
            <PasswordStrength password={password1} similarityTip />
            <div className={classnames('field', '-floating', { '-error': errors.password2 })}>
              <div className="field-container">
                <input
                  {...register('password2', {
                    required: 'This field is required.',
                    validate: value => value === password1 || "passwords don't match"
                  })}
                  type={password2Visible ? 'text' : 'password'}
                  placeholder=" "
                  id="change-retype-password"
                  {...ariaErrorProps('change-retype-password', errors.password2)}
                />
                <label htmlFor="change-retype-password">Retype your new password</label>
                <i
                  className={classnames('icon', password2Visible ? 'icon-passcodewatch' : 'icon-passcodewatch disabled')}
                  aria-label="Toggle password visibility"
                  onClick={() => setPassword2Visible(!password2Visible)}
                  onKeyUp={event => keyUpHandler(event, () => setPassword2Visible(!password2Visible))}
                  tabIndex="0"
                />
                <InlineError id="change-retype-password" message={errors.password2?.message} />
              </div>
            </div>
            <button
              type="submit"
              className="btn -wide -blue-2"
              style={{ width: '100%' }}
              disabled={!isDirty || isSubmitting || !isPasswordValid(password1)}
            >
              Change password
            </button>
          </form>

          <div className="auth-alt">
            or <Link to="/login">Sign In</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

ChangePassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

export default connect(
  null,
  dispatchSelector
)(ChangePassword)
